import Grid from '@/global/components/ui/Grid'
import {
    FormDatePicker,
    FormField,
    FormFieldCheckbox,
} from 'global/components/Form'
import AutocompleteTecnico from '../atoms/AutocompleteTecnico'

export default function FormTreinamento() {
    return (
        <Grid container className="mb-2">
            <Grid item xs={12} sm={5}>
                <FormDatePicker
                    name="data"
                    label="Data"
                    type="datetime-local"
                    required
                />
            </Grid>
            <Grid item xs={12} sm={7}>
                <FormField
                    name="quemRecebeu"
                    label="Quem recebeu"
                    required
                    max={50}
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteTecnico />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="observacao"
                    label="Observação"
                    multiline
                    max={250}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldCheckbox name="cobranca" label="Cobrança" />
            </Grid>
        </Grid>
    )
}
